import React from 'react'

const IcArrowRight = (props) => {
    return <svg {...props} width={10} height={19} viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L7.7099 8.12927C8.4347 8.89937 8.4347 10.1006 7.7099 10.8707L1 18" stroke="black" strokeWidth={2} strokeLinecap="round" />
  </svg>
}

export default IcArrowRight